// @flow
import AdminButton from "../GUI_COMMON/COMPONENTS/AdminButton";
import AuthButton from "../GUI_COMMON/COMPONENTS/AuthButton";
import React, {useContext, useEffect} from "react";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import {useHistory} from "react-router";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useCookies} from "react-cookie";
import {useLocation} from "react-router-dom";
import {gotServerInfo} from "../ACTIONS/clientActions";
import {setClientInfo} from "../GUI_COMMON/ACTIONS/commonClientActions";
import {setupProfilesAndSampleAndMagType} from "../SUPPORT/startup";
import CommonClientApi from "../GUI_COMMON/API/commonClientApi";
import NotificationButton from "./NotificationButton";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import {checkAndReportWwwAppUpdate} from "../GUI_COMMON/SUPPORT/update";
import UserActivityMonitor from "../GUI_COMMON/COMPONENTS/UserActivityMonitor";

const ARCHIVER_WEB_API_VERSION = "2.0";

interface HeaderProps {
    hideAdmin?: boolean,
    title?: string
}

const Header: React.FC<HeaderProps> = ({hideAdmin, title="KeepTrack Archiver"}) => {
    
    const [globalState, dispatch] = useContext(StoreContext);
    const location = useLocation();
    const history = useHistory();
    const [cookies,] = useCookies();
    
    useEffect(() => {
        console.debug("header starting up...");
    },[]);
    
    useEffect(() => {
        
        if (globalState?.archiverServerInfo.initialized === false) {
            
            CommonClientApi.setupHeader(cookies.liToken);
            CommonClientApi.setupHeaderApiVersion(ARCHIVER_WEB_API_VERSION);
            CommonClientApi.getServerInfo()
            .then(({name, version, demoMode, requiredDbVersion, dbVersion, localTimeUtc, config}) => {
                dispatch(gotServerInfo(name, version, demoMode, 
                    requiredDbVersion, dbVersion, localTimeUtc, config));
            })
            .catch(() => { 
                console.error("failed to get server info");
            });
            checkAndReportWwwAppUpdate();
        }
    }, [globalState.archiverServerInfo.initialized]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // ensure the token is available after refreshes.
        if (!globalState.clientInfo || globalState.clientInfo.userId === -1) {
            // HERE WE RE-REQUEST EVERYTHING NEEDED FROM THE SERVER IN THE EVENT OF A USER REFRESH
            dispatch(setClientInfo(cookies.liId, cookies.liFullName, cookies.liType));
        }

    }, [globalState.clientInfo]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (LIUtils.isAuthenticatedHook(cookies) && globalState.profiles.initialized !== true) {
            setupProfilesAndSampleAndMagType(dispatch);
        }
    }, [globalState.profiles.initialized]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    /**
     * get all profiles from the server and setup the global store with them.
     */
    
    function handleSignoutClicked() {
        history.push("/signout");
    }
    
    function handleInactiveUser() {

        console.log("*** User is inactive ... logging them out")
        history.push("/signout");
    }

    function handleAdminClicked() {
        history.push("/adminPage");
    }
    
    function redirectToNotifications() {
        if (!location.pathname.startsWith("/notifications")) {
            history.push("/notifications");
        }
    }

    function showToDashboardButtonIfRequired() {
        if (location.pathname.indexOf("dashboard") === -1) { // show back
            return <span className="fa-stack fa-sm">
                      <i className="li-fg-primary fa fa-circle fa-stack-2x"></i>
                      <i className="fa fa-home fa-stack-1x li-fg-white"></i>
                    </span>;
        }
        return null;
    }

    function showAdminButtonIfRequired() {
        if (hideAdmin) {
            return;
        }
        if (!LIUtils.UserHasLevel(cookies, "SERVICE") && !LIUtils.UserHasLevel(cookies, "ADMIN")) {
            return;
        }

        return (<AdminButton adminClicked={handleAdminClicked}/>);
    }

    function showNotificationIconIfRequired() {
        if (globalState.notifications.numNotifs >0) {
            return <div className="mr-4 align-self-center">
                <NotificationButton numUnread={globalState.notifications.numUnread} numNotifs={globalState.notifications.numNotifs} onClick={redirectToNotifications}/>
            </div>;
        }
    }
    
    if (LIUtils.isAuthenticatedHook(cookies) === false) {
        Popup.show("Session Expired","<p>Your session has expired.</p><p>Please dismiss this dialog to login again.</p>",
            () => history.push("/signout")
        );
    }

    return (<>
                <title>{title}</title>
                <UserActivityMonitor timeoutInMinutes={globalState?.archiverServerInfo?.config?.inactiveTimeout??0} onInactive={handleInactiveUser}/>
                <div className="row mt-3 li-page-header-bg">
                    <div className="col-12 col-sm-6 li-font-large d-inline font-weight-bold p-0 m-0 align-self-center">
                        <div className="li-pointer d-inline-block" onClick={()=>history.push("/dashboard")}>
                            {showToDashboardButtonIfRequired()}
                            <div className="d-inline">{globalState.archiverServerInfo.name}</div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 align-self-center">
                        <div className="d-flex m-0 p-0 justify-content-between">
                            <div className="">
                                {showAdminButtonIfRequired()}
                            </div>
                            <div className="">
                                <div className="d-flex">
                                {showNotificationIconIfRequired()}
                                <AuthButton user={globalState.clientInfo?.fullName} signOutClicked={handleSignoutClicked}
                                            nameBelow/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-2 w-100 mb-3"/>
            </>);
}

export default Header;